import axios from 'axios';

const apiCode = process.env.REACT_APP_AZURE_CODE;

const uploadImage = {

  /**
   * convierte una imagen a s3
   */
  imageToS3: async (data) => {
    const response = axios({
      url: `https://backend-metior.azurewebsites.net/api/img?code=${apiCode}`,
      method: 'POST',
      data,
    })
      .then((res) => res.data)
      .catch((err) => {
        const error = err.response?.data.message || err.toString();
        return { error: { message: error.responseJSON?.message } };
      });
    return response;
  },

};

export default uploadImage;
